// ('EVENT', { type: 'search', keyword: searchTerm });
export const track = (key, opts) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(`etch.${key}`, {
      ...opts,
      etchVersion: 1
    });
  }
};
